import './App.css';
import {useRoutes} from 'hookrouter';

import ChangePassword from './components/changePassword/ChangePassword';
import Login from './components/login/Login';
import NotFound from './components/notFound/NotFound';
import ResetRequest from './components/resetRequest/ResetRequest';
import ResetPassword from './components/resetPassword/ResetPassword';

function App() {
  const routes = useRoutes({
    '/': () => <Login />,
    '/login': () => <Login />,
    '/resetRequest': () => <ResetRequest />,
    '/resetPassword': () => <ResetPassword />,
    '/changePassword': () => <ChangePassword />
  });

    return (
      <div className="App">
      <header className="App-header">
        {routes || <NotFound />}
       </header>
     </div>
   );
}

export default App;
